export default __webpack_public_path__ + "static/media/prm-logo-white.6af05042.png";